// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.menu-drawer {
  min-width: var(--menu-shrink-width);
  max-width: var(--menu-shrink-width);
  background-color: var(--white-color-lightest);
  color: var(--dark-color-dark);
  transition: min-width 0.3s ease, max-width 0.3s ease, box-shadow 0.3s ease;
  box-shadow: var(--omni-shadow-hidden);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1 0 auto;
  z-index: var(--z-index-menu);
  -webkit-overflow-scrolling: touch;
  position: relative;
  top: 0;
  outline: 0;
  left: 0;
  border-right: 1px solid var(--white-color-dark);
  /* モバイル */
}
@media (width < 752px) {
  .menu-drawer {
    min-width: 0px;
    max-width: 0px;
  }
}
.menu-drawer .menu-header {
  cursor: pointer;
  border-bottom: 1px solid var(--white-color-dark);
  padding: 8px;
  height: 48px;
  min-height: 48px;
  box-sizing: border-box;
  flex-shrink: 0;
}
.menu-drawer .menu-header .menu-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  height: 100%;
  overflow: hidden;
}
.menu-drawer .menu-header .menu-logo-button {
  flex-shrink: 0;
  margin-left: 13px;
  width: 22px;
  height: 32px;
  padding: 0;
  border: none;
  background: transparent;
  overflow: hidden;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: width 0.3s ease;
}
.menu-drawer .menu-header .logo {
  height: 22px;
  width: auto;
  max-width: none;
  max-height: none;
  display: block;
}
.menu-drawer .menu-header .menu-switch-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  flex-shrink: 0;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--dark-color-dark);
  cursor: pointer;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s;
}
.menu-drawer .menu-header .menu-switch-button:hover {
  background: var(--dark-color-dark-transparent-10);
}
.menu-drawer .menu-list {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}
.menu-drawer .button {
  font-weight: 400;
  letter-spacing: 2px;
  font-size: 14px;
}
.menu-drawer .button.hidden {
  border-radius: 0px;
}
.menu-drawer .menu-group .group-icon {
  transition: transform 0.3s;
}
.menu-drawer .menu-group .menu-group-list {
  min-height: 0px;
  max-height: 0px;
  transition: min-height 0.3s, max-height 0.3s;
  overflow: hidden;
}
.menu-drawer .menu-group.group-open .group-icon {
  transform: rotate(90deg);
}
.menu-drawer .menu-group.group-open .menu-group-list {
  min-height: 192px;
  max-height: 192px;
}
.menu-drawer .menu-group.group-open .menu-group-list .menu-item .button {
  color: var(--font_active_sub_color);
}
.menu-drawer .menu-group .menu-item .button {
  padding-right: 20px;
}
.menu-drawer .menu-group .menu-item .button .button-label {
  font-size: var(--text-size-light-small);
}
.menu-drawer .menu-item, .menu-drawer .menu-group {
  max-width: var(--menu-expand-width);
  min-width: var(--menu-expand-width);
}
.menu-drawer .menu-item .button, .menu-drawer .menu-group .button {
  padding-right: 10px;
}
.menu-drawer .menu-item .button .button-label, .menu-drawer .menu-group .button .button-label {
  justify-content: space-between;
}
.menu-drawer .menu-item .menu-item-icon-area, .menu-drawer .menu-group .menu-item-icon-area {
  width: var(--menu-shrink-width);
  min-width: var(--menu-shrink-width);
}
.menu-drawer .menu-item.selected, .menu-drawer .menu-group.selected {
  transition: color 0.3s background-color 0.3s;
  pointer-events: none;
}
.menu-drawer .menu-item.selected *, .menu-drawer .menu-group.selected * {
  color: var(--primary-color-main);
}
.menu-drawer .menu-item.selected .button, .menu-drawer .menu-group.selected .button {
  background-color: var(--primary-color-main-transparent-25);
}
.menu-drawer .menu-item.disabled, .menu-drawer .menu-group.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.menu-drawer .menu-item.disabled button, .menu-drawer .menu-group.disabled button {
  cursor: not-allowed;
}
.menu-drawer .menu-ops-section {
  max-width: var(--menu-expand-width);
  min-width: var(--menu-expand-width);
  border-top: 1px solid var(--white-color-dark);
  margin-top: 8px;
  padding-top: 8px;
}
.menu-drawer .menu-ops-section .menu-ops-heading {
  width: 100%;
  display: flex;
  align-items: center;
  overflow: hidden;
  color: var(--disabled-font-color);
  height: 0px;
  opacity: 0;
  transition: height 0.3s ease, opacity 0.2s;
}
.menu-drawer .menu-ops-section .menu-ops-heading-label {
  padding-left: 20px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  white-space: nowrap;
  line-height: 1;
}
.menu-drawer .menu-footer {
  display: flex;
  flex-direction: column;
  padding: 4px 0;
  flex-shrink: 0;
  border-top: 1px solid var(--white-color-dark);
}
.menu-drawer .menu-footer .logout-item {
  width: var(--menu-expand-width);
  min-width: var(--menu-expand-width);
  min-height: 36px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 10px 0 0;
  border: none;
  background: transparent;
  color: var(--dark-color-dark);
  font-family: inherit;
  font-weight: 400;
  letter-spacing: 2px;
  font-size: 14px;
  text-align: left;
  cursor: pointer;
}
.menu-drawer .menu-footer .logout-item:hover {
  background: var(--dark-color-dark-transparent-10);
}
.menu-drawer .menu-footer .logout-item-icon-area {
  width: var(--menu-shrink-width);
  min-width: var(--menu-shrink-width);
  padding: 6px 12px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}
.menu-drawer .menu-footer .logout-item-icon-area svg, .menu-drawer .menu-footer .logout-item-icon-area img {
  transform: translateX(-2px);
}
.menu-drawer .menu-footer .logout-label {
  padding: 6px 12px;
  white-space: nowrap;
  flex: 1 1;
  overflow: hidden;
  opacity: 0;
  transition: opacity 0.2s;
}
.menu-drawer.open {
  max-width: var(--menu-expand-width);
  min-width: var(--menu-expand-width);
  box-shadow: var(--omni-shadow);
  /* グローバルスコープで--menu-current-widthを更新 */
}
.menu-drawer.open ~ * {
  --menu-current-width: var(--menu-expand-width);
}
.menu-drawer.open .menu-logo-button {
  width: 96px;
}
.menu-drawer.open .menu-switch-button {
  opacity: 1;
  pointer-events: auto;
}
.menu-drawer.open .menu-ops-section .menu-ops-heading {
  height: 20px;
  opacity: 1;
}
.menu-drawer.open .menu-footer .logout-label {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/Menu.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,mCAAA;EACA,mCAAA;EACA,6CAAA;EACA,6BAAA;EAGA,0EAAA;EACA,qCAAA;EAEA,gBAAA;EAEA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;EAEA,4BAAA;EACA,iCAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,OAAA;EACA,+CAAA;EAEA,SAAA;AAJF;AAKE;EA1BF;IA2BI,cAAA;IACA,cAAA;EAFF;AACF;AAIE;EACE,eAAA;EACA,gDAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;AAFJ;AAII;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;AAFN;AAMI;EACE,cAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;AAJN;AAOI;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AALN;AAQI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,6BAAA;EACA,eAAA;EACA,UAAA;EACA,oBAAA;EACA,wBAAA;AANN;AAQM;EACE,iDAAA;AANR;AAWE;EACE,SAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AATJ;AAYE;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;AAVJ;AAYI;EACE,kBAAA;AAVN;AAeI;EACE,0BAAA;AAbN;AAgBI;EACE,eAAA;EACA,eAAA;EACA,4CAAA;EACA,gBAAA;AAdN;AAmBM;EACE,wBAAA;AAjBR;AAmBM;EACE,iBAAA;EACA,iBAAA;AAjBR;AAmBU;EACE,mCAAA;AAjBZ;AAwBM;EACE,mBAAA;AAtBR;AAwBQ;EACE,uCAAA;AAtBV;AA4BE;EACE,mCAAA;EACA,mCAAA;AA1BJ;AA4BI;EACE,mBAAA;AA1BN;AA4BM;EACE,8BAAA;AA1BR;AA8BI;EACE,+BAAA;EACA,mCAAA;AA5BN;AA+BI;EACE,4CAAA;EACA,oBAAA;AA7BN;AA+BM;EACE,gCAAA;AA7BR;AAgCM;EACE,0DAAA;AA9BR;AAmCI;EACE,YAAA;EACA,oBAAA;AAjCN;AAmCM;EACE,mBAAA;AAjCR;AAuCE;EACE,mCAAA;EACA,mCAAA;EACA,6CAAA;EACA,eAAA;EACA,gBAAA;AArCJ;AAuCI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iCAAA;EACA,WAAA;EACA,UAAA;EACA,0CAAA;AArCN;AAwCI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AAtCN;AA2CE;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,cAAA;EACA,6CAAA;AAzCJ;AA2CI;EACE,+BAAA;EACA,mCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,6BAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAzCN;AA2CM;EACE,iDAAA;AAzCR;AA6CI;EACE,+BAAA;EACA,mCAAA;EACA,iBAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA3CN;AA8CM;EACE,2BAAA;AA5CR;AAgDI;EACE,iBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;EACA,wBAAA;AA9CN;AAkDE;EACE,mCAAA;EACA,mCAAA;EACA,8BAAA;EAEA,sCAAA;AAjDJ;AAkDI;EACE,8CAAA;AAhDN;AAmDI;EACE,WAAA;AAjDN;AAoDI;EACE,UAAA;EACA,oBAAA;AAlDN;AAqDI;EACE,YAAA;EACA,UAAA;AAnDN;AAsDI;EACE,UAAA;AApDN","sourcesContent":[".menu-drawer{\r\n  min-width: var(--menu-shrink-width);\r\n  max-width: var(--menu-shrink-width);\r\n  background-color: var(--white-color-lightest);\r\n  color: var(--dark-color-dark);\r\n  \r\n  // 幅は min-width と max-width の両方で決まるため、両方を同じ時間で動かして滑らかに開閉する\r\n  transition: min-width .3s ease, max-width .3s ease, box-shadow .3s ease;\r\n  box-shadow: var(--omni-shadow-hidden);\r\n  // スクロールは .menu-list の中だけで行う（ヘッダーとログアウトは固定）\r\n  overflow: hidden;\r\n\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  flex: 1 0 auto;\r\n\r\n  z-index: var(--z-index-menu);\r\n  -webkit-overflow-scrolling: touch;\r\n  position: relative;\r\n  top: 0;\r\n  outline: 0;\r\n  left: 0;\r\n  border-right: 1px solid var(--white-color-dark);\r\n\r\n  /* モバイル */\r\n  @media (width < 752px) {\r\n    min-width: 0px;\r\n    max-width: 0px;\r\n  }\r\n\r\n  .menu-header{\r\n    cursor: pointer;\r\n    border-bottom: 1px solid var(--white-color-dark);\r\n    padding: 8px;\r\n    height: 48px;\r\n    min-height: 48px;\r\n    box-sizing: border-box;\r\n    flex-shrink: 0;\r\n\r\n    .menu-header-row{\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      gap: 8px;\r\n      height: 100%;\r\n      overflow: hidden;\r\n    }\r\n\r\n    // 閉じている時はロゴ先頭のマーク(22px)だけを見せ、押すとメニューを開く\r\n    .menu-logo-button{\r\n      flex-shrink: 0;\r\n      margin-left: 13px;\r\n      width: 22px;\r\n      height: 32px;\r\n      padding: 0;\r\n      border: none;\r\n      background: transparent;\r\n      overflow: hidden;\r\n      display: flex;\r\n      align-items: center;\r\n      cursor: pointer;\r\n      transition: width .3s ease;\r\n    }\r\n\r\n    .logo{\r\n      height: 22px;\r\n      width: auto;\r\n      max-width: none;\r\n      max-height: none;\r\n      display: block;\r\n    }\r\n\r\n    .menu-switch-button{\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      width: 32px;\r\n      height: 32px;\r\n      min-width: 32px;\r\n      min-height: 32px;\r\n      flex-shrink: 0;\r\n      padding: 0;\r\n      border: none;\r\n      border-radius: 8px;\r\n      background: transparent;\r\n      color: var(--dark-color-dark);\r\n      cursor: pointer;\r\n      opacity: 0;\r\n      pointer-events: none;\r\n      transition: opacity .2s;\r\n\r\n      &:hover{\r\n        background: var(--dark-color-dark-transparent-10);\r\n      }\r\n    }\r\n  }\r\n\r\n  .menu-list{\r\n    flex: 1;\r\n    min-height: 0;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n  }\r\n\r\n  .button{\r\n    font-weight: 400;\r\n    letter-spacing: 2px;\r\n    font-size: 14px;\r\n\r\n    &.hidden{\r\n      border-radius: 0px;\r\n    }\r\n  }\r\n\r\n  .menu-group{\r\n    .group-icon{\r\n      transition: transform 0.3s;\r\n    }\r\n\r\n    .menu-group-list{\r\n      min-height: 0px;\r\n      max-height: 0px;\r\n      transition: min-height 0.3s, max-height 0.3s;\r\n      overflow: hidden;\r\n      \r\n    }\r\n\r\n    &.group-open{\r\n      .group-icon{\r\n        transform: rotate(90deg);\r\n      }\r\n      .menu-group-list{\r\n        min-height: 192px;\r\n        max-height: 192px;\r\n        .menu-item{\r\n          .button{\r\n            color: var(--font_active_sub_color);\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .menu-item{\r\n      .button{\r\n        padding-right: 20px;\r\n\r\n        .button-label{\r\n          font-size: var(--text-size-light-small);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .menu-item, .menu-group{\r\n    max-width: var(--menu-expand-width);\r\n    min-width: var(--menu-expand-width);\r\n    \r\n    .button{\r\n      padding-right: 10px;\r\n\r\n      .button-label{\r\n        justify-content: space-between;\r\n      }\r\n    }\r\n\r\n    .menu-item-icon-area{\r\n      width: var(--menu-shrink-width);\r\n      min-width: var(--menu-shrink-width);\r\n    }\r\n\r\n    &.selected{\r\n      transition: color 0.3s background-color 0.3s;\r\n      pointer-events: none;\r\n\r\n      *{\r\n        color: var(--primary-color-main);\r\n      }\r\n\r\n      .button{\r\n        background-color: var(--primary-color-main-transparent-25);\r\n      }\r\n    }\r\n\r\n    // 既存のスタイルに追加\r\n    &.disabled {\r\n      opacity: 0.5;\r\n      pointer-events: none;\r\n  \r\n      button {\r\n        cursor: not-allowed;\r\n      }\r\n    }\r\n  }\r\n\r\n  // 運営ツール（運営権限のみ表示）\r\n  .menu-ops-section{\r\n    max-width: var(--menu-expand-width);\r\n    min-width: var(--menu-expand-width);\r\n    border-top: 1px solid var(--white-color-dark);\r\n    margin-top: 8px;\r\n    padding-top: 8px;\r\n\r\n    .menu-ops-heading{\r\n      width: 100%;\r\n      display: flex;\r\n      align-items: center;\r\n      overflow: hidden;\r\n      color: var(--disabled-font-color);\r\n      height: 0px;\r\n      opacity: 0;\r\n      transition: height .3s ease, opacity .2s;\r\n    }\r\n\r\n    .menu-ops-heading-label{\r\n      padding-left: 20px;\r\n      font-size: 11px;\r\n      font-weight: 700;\r\n      letter-spacing: 2px;\r\n      white-space: nowrap;\r\n      line-height: 1;\r\n    }\r\n  }\r\n\r\n  // ログアウト（最下部に固定。閉じている時はアイコンのみ）\r\n  .menu-footer{\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding: 4px 0;\r\n    flex-shrink: 0;\r\n    border-top: 1px solid var(--white-color-dark);\r\n\r\n    .logout-item{\r\n      width: var(--menu-expand-width);\r\n      min-width: var(--menu-expand-width);\r\n      min-height: 36px;\r\n      display: flex;\r\n      flex-direction: row;\r\n      align-items: center;\r\n      padding: 0 10px 0 0;\r\n      border: none;\r\n      background: transparent;\r\n      color: var(--dark-color-dark);\r\n      font-family: inherit;\r\n      font-weight: 400;\r\n      letter-spacing: 2px;\r\n      font-size: 14px;\r\n      text-align: left;\r\n      cursor: pointer;\r\n\r\n      &:hover{\r\n        background: var(--dark-color-dark-transparent-10);\r\n      }\r\n    }\r\n\r\n    .logout-item-icon-area{\r\n      width: var(--menu-shrink-width);\r\n      min-width: var(--menu-shrink-width);\r\n      padding: 6px 12px;\r\n      box-sizing: border-box;\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n\r\n      // アイコンの見た目の重心を上のメニュー項目のアイコン列にそろえる\r\n      svg, img {\r\n        transform: translateX(-2px);\r\n      }\r\n    }\r\n\r\n    .logout-label{\r\n      padding: 6px 12px;\r\n      white-space: nowrap;\r\n      flex: 1;\r\n      overflow: hidden;\r\n      opacity: 0;\r\n      transition: opacity .2s;\r\n    }\r\n  }\r\n\r\n  &.open {\r\n    max-width: var(--menu-expand-width);\r\n    min-width: var(--menu-expand-width);\r\n    box-shadow: var(--omni-shadow);\r\n\r\n    /* グローバルスコープで--menu-current-widthを更新 */\r\n    & ~ * {\r\n      --menu-current-width: var(--menu-expand-width);\r\n    }\r\n\r\n    .menu-logo-button{\r\n      width: 96px;\r\n    }\r\n\r\n    .menu-switch-button{\r\n      opacity: 1;\r\n      pointer-events: auto;\r\n    }\r\n\r\n    .menu-ops-section .menu-ops-heading{\r\n      height: 20px;\r\n      opacity: 1;\r\n    }\r\n\r\n    .menu-footer .logout-label{\r\n      opacity: 1;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
